import React, { useState } from "react";
import {
  Box,
  Typography,
  Stack,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  ButtonBase
} from "@mui/material";
import Avatar from '@material-ui/core/Avatar';
import { makeStyles } from '@material-ui/core/styles';
import { api_call, getDeviceImageUri, getLocalTimezone } from "../helpers/untils";
import TripDailyTimelineModal from "./TripDailyTimelineModal";
import TimeTuroTripListContent from "./TimeTuroTripListContent";
import TripTimelineSpeedBox from "./TripTimelineSpeedBox";
import { Grid } from "@material-ui/core";
import { useEffect } from "react";
import { MACHINE_ENVIRONMENT } from "../config/constant";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: '25px',
    height: '25px',
    filter: 'brightness(0) invert(1)',
  },
  avatar: {
    width: '25px',
    height: '25px',
    transform: 'scale(2)'
  }
}));

const TripInProgressContent = (props) => {
  const { pageData = {} } = props;
  const { device } = pageData;
  const deviceId = device?.id;
  const classes = useStyles();

  const [formData, setFormData] = useState(null);

  const getTripInProgressData = async () => {
    const iana_timezone = getLocalTimezone();
    const url = `/api/device-timeline/in-progress-trip-data?deviceId=${deviceId}&iana_timezone=${iana_timezone}`;
    const response = await api_call(url);
    if (response.ok) {
      const data = await response.json();
      setFormData(data);
    } else {
      setFormData(null);
    }
  }

  useEffect(() => {
    /// fist time, call this function
    getTripInProgressData();

    /// set timer ///////////////////
    const step = MACHINE_ENVIRONMENT === 'dev' ? 6 * 1000 : 60 * 1000
    const id = setInterval(() => { getTripInProgressData() }, step);
    return () => clearInterval(id);
  }, []);

  return (
    <Box>
      {
        (formData) ? (
          <>
            <Grid container spacing={4}>
              <Grid item>
                <Stack direction={`column`} spacing={1}>
                  <Typography style={{ fontWeight: 600 }}>Trip In Progress</Typography>
                  <Typography>{formData?.trip_data?.tripStartTimeLocalStr}</Typography>
                </Stack>
              </Grid>
              <Grid item>
                <Stack direction={`column`} spacing={1}>
                  <Typography>{`${formData?.trip_data?.maxSpeed} ${formData?.trip_data?.speedUnitStr}`}</Typography>
                  <Typography>{`${formData?.trip_data?.tripMinutes.toLocaleString()}`} mins</Typography>
                </Stack>
              </Grid>
            </Grid>
          </>
        ) : (
          <></>
        )
      }
    </Box>
  )
}

export default TripInProgressContent;
